﻿export const calculateDuration = (startTime: Date) => (new Date().getTime()) - startTime.getTime();